export default __webpack_public_path__ + "assets/img/product-market-fit.b5faa8a9c57101002f9487de3b4e9f58.png";